import i18n from "i18next";
import detector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import translationIT from "./locales/it/translation.json";
import translationES from "./locales/es/translation.json";
import translationENG from "./locales/eng/translation.json";

// Translation resources type
interface Resources {
  [key: string]: {
    translation: typeof translationIT | typeof translationES | typeof translationENG;
  };
}

// The translations
const resources: Resources = {
  it: {
    translation: translationIT,
  },
  es: {
    translation: translationES,
  },
  en: {
    translation: translationENG,
  },
};

i18n
  .use(detector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    fallbackLng: "en", // use en if detected lng is not available

    detection: {
      order: ["querystring", "localStorage", "navigator"],
      lookupQuerystring: "lng",
      lookupLocalStorage: "I18N_LANGUAGE",
      caches: ["localStorage"],
    },

    keySeparator: false, // we do not use keys in form messages.welcome
    nsSeparator: false,

    interpolation: {
      escapeValue: false, // react already safes from xss
    },

    react: {
      useSuspense: false,
    },
  });

export default i18n;
